import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { companyCalendarDate } from "@/lib/companyTime";

/** Date-only controls use the company calendar for Today and empty defaults. */
export class CompanyDateAdapter extends AdapterDateFns {
  constructor(...args: ConstructorParameters<typeof AdapterDateFns>) {
    super(...args);
    const date = this.date;
    this.date = ((value?: string | null) =>
      value === undefined
        ? companyCalendarDate()
        : date(value)) as unknown as typeof this.date;
  }
}
